import axios from "axios";

export const createApiClient = (getAccessToken, baseURL = process.env.REACT_APP_BASE_API_URL) => {
    const client = axios.create({ baseURL });

    client.interceptors.request.use(async (config) => {
        const accessToken = await getAccessToken();
        config.headers = config.headers || {};
        if (typeof config.headers.set === "function") {
            config.headers.set("Authorization", `Bearer ${accessToken}`);
        } else {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    });

    return client;
};
